/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Kindle_Auto_ScrollInputs */

const en_mobile_kindle_auto_scroll = /** @type {(inputs: Mobile_Kindle_Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-scroll`)
};

const es_mobile_kindle_auto_scroll = /** @type {(inputs: Mobile_Kindle_Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazamiento automático`)
};

/**
* | output |
* | --- |
* | "Auto-scroll" |
*
* @param {Mobile_Kindle_Auto_ScrollInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_kindle_auto_scroll = /** @type {((inputs?: Mobile_Kindle_Auto_ScrollInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Kindle_Auto_ScrollInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_kindle_auto_scroll(inputs)
	return en_mobile_kindle_auto_scroll(inputs)
});